<div>
  <ion-label class="pillHeader">{{ headerLabel }}</ion-label>

  <ion-row class="pill">
    <ion-col class="leftSide side">
      @if (leftImageSrc || leftIcon) {
        <div class="leftImage image">
          @if (leftImageSrc) {
            <img src="{{ leftImageSrc }}" />
          } @else {
            <span class="{{ leftIcon }}"></span>
          }
        </div>
      }

      @if (leftTextLineOne) {
        <p class="leftText leftTextLineOne line pillText">
          {{ leftTextLineOne }}
        </p>
      }

      @if (leftTextLineTwo) {
        <p class="leftText leftTextLineTwo line pillText">
          {{ leftTextLineTwo }}
        </p>
      }

      @if (!leftTextLineOne || !leftTextLineTwo) {
        <p class="leftText pillText">{{ leftText }}</p>
      }
    </ion-col>

    <ion-col class="rightSide side">
      @if (rightImageSrc || rightIcon) {
        <div class="rightImage image">
          @if (rightImageSrc) {
            <img src="{{ rightImageSrc }}" />
          } @else {
            <span class="{{ rightIcon }}"></span>
          }
        </div>
      }

      @if (rightTextLineOne) {
        <p class="rightText rightTextLineOne line pillText">
          {{ rightTextLineOne }}
        </p>
      }

      @if (rightTextLineTwo) {
        <p class="rightText rightTextLineTwo line pillText">
          {{ rightTextLineTwo }}
        </p>
      }

      @if (!rightTextLineOne || !rightTextLineTwo) {
        <p class="rightText pillText">{{ rightText }}</p>
      }
    </ion-col>
  </ion-row>
</div>
